import { LoadableBackground } from '@confluence/loadable';

export const PremiumAdminEvent = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-analytics-eventsPremiumAdminEvent" */ '../src/analytics-events/PremiumAdminEvent'
			)
		).PremiumAdminEvent,
});
